export default __webpack_public_path__ + "static/media/wallet-card-theme1.e80ff684.svg";